import { CLIENT_ENV } from '@/config/configuration';

export const DAVINCI_CDN = CLIENT_ENV().NEXT_PUBLIC_DAVINCI_ASSETS_CDN || 'https://cdn.davinci.care';
export const CHANNEL_VIDEO = 'ONLINE';
export const CHANNEL_STUDIO = 'ONLINE';

export const BASE_URL = CLIENT_ENV().NEXT_PUBLIC_SITE_URL ?? '';
